module.exports = __webpack_public_path__ + "static/media/HomeSecurity.4cbc3dbe.jpg";